<!-- 根据区域检索摄像头 -->
<template>
  <div class="app-area-list">
    <div class="search-box">
      <el-input
        v-model="searchDevice"
        clearable
        style="width: 80%"
        :placeholder="$t('business.placeholder.keyword')"
      >
      </el-input>
      <span> | </span>
      <img
        @click="searchIptChange"
        src="@src/common/assets/images/search.png"
        alt=""
      />
    </div>
    <div class="area-container">
      <el-scrollbar ref="scrollBar" class="scroll-bar">
        <el-tree
          class="full-height"
          ref="appAreaTree"
          :data="dataList"
          node-key="id"
          :props="defaultProps"
          :show-checkbox="multiCheck"
          highlight-current
          :default-expanded-keys="expandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          @node-click="getCheckNode"
          @check="checkChange"
          :filter-node-method="filterNode"
        >
          <div
            unselectable="on"
            onselectstart="return false;"
            style="-moz-user-select: none"
            class="node"
            :title="data.name"
            slot-scope="{ data }"
            :draggable="data.nodeType == 'device' ? true : false"
            :class="[
              {
                'out-line':
                  parseInt(data.status) !== 1 && data.nodeType === 'device'
              },
              data.color,
              data.nodeType == 'device' ? 'showDrag' : ''
            ]"
          >
         
            <i
              v-show="data.nodeType === 'device'"
              :style="{ color: data.color }"
              class="iconfont-lunan icon-lunan-shexiangtou"
            ></i>
            <!-- <span :style="{color: data.color}">{{data.name}}</span> -->
            <span
              style="
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
              "
              >{{ data.name }}</span
            >
            <span v-show="data.nodeType !== 'device' && showPercentage">{{
              getInlinePercentage(data)
            }}</span>
            <i
              v-show="data.nodeType === 'device'"
              :class="[
                'icon',
                'iconfont-lunan',
                cameraIcon(data),
                'camera-type-icon'
              ]"
            ></i>
          </div>
        </el-tree>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { Cache } from "$utils";
export default {
  props: {
    multiCheck: {
      type: Boolean,
      default: false
    },
    showPercentage: {
      type: Boolean,
      default: true
    },
    isCollection: {
      type: Boolean,
      default: false
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    searchDevice(val) {
      this.$refs.appAreaTree.filter(val);
    }
  },
  data() {
    return {
      dataList: [],
      defaultProps: {
        children: "children",
        label: "name",
        id: "id"
      },
      searchDevice: "",
      cameraData: [],
      searchDeviceChange: false,
      // 默认展开的数组
      expandedKeys: []
    };
  },
  mounted() {
    this.queryDevice();
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return (data.name || "").indexOf(value) !== -1;
    },
    showRedIcon(data, bfdata) {
      let redData = bfdata;
      const self = this;
      if (data !== null) {
        data.forEach((item) => {
          if (item.nodeType == "device") {
            let nameCopy = item.name;
            item.name = "";
            let isHave = redData.some((el) => {
              return el.deviceId == item.thirdCameraId;
            });
            // this.$nextTick(() => {
            item.name = nameCopy;
            !isHave ? delete item.color : (item.color = "showIcon");
            // })
          }
          if (item.children) {
            self.showRedIcon(item.children, redData);
          }
          return;
        });
      }
    },
    showIcon(data) {
      console.log(data);
      var nodes = this.dataList[0].children;
      this.showRedIcon(nodes, data);
    },
    searchIptChange() {
      this.$refs.appAreaTree.filter(this.searchDevice);
    },
    cameraIcon(data) {
      switch (data.ability) {
        case "0":
          return "";
        case "1":
          return "icon-lunan-renyuanbukong";
        case "2":
          return "icon-lunan-cheliangbukong";
        // case '3':return 'icon iconfont icon-b_icon__cam_hem';
        default:
          return "";
      }
    },
    // 在线率
    getInlinePercentage(data) {
      data.inlineCount = data.inlineCount || 0;
      data.totalCount = data.totalCount || 0;
      let percentage = parseInt((data.inlineCount / data.totalCount) * 100);
      return `(${data.inlineCount}/${data.totalCount};${percentage || 0}%)`;
    },
    // 查询区域树
    queryDevice() {
      this.$fetch("/bms/device/queryDeviceWorkGroupDeviceTree.json", {
        deviceType: 10,
        searchType: "captureCamera"
      }).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          const account = Cache.get("CACHE_USER_INFO");
          if (this.searchDevice != "") {
            // if (response.returnObj && response.returnObj.length) {
            //   this.areaNameList = this.deviceDataPro(response.returnObj);
            //   this.dataList = response.returnObj;
            //   this.checkChildNodes(this.searchDevice, response.returnObj);
            // } else {
            //   this.expandedKeys = [account.parkInfo.areaDevGroupCode];
            //   this.dataList = [];
            // }
          } else {
            this.expandedKeys = [account.parkInfo.areaDevGroupCode];
            let result = response.returnObj;
            this.areaNameList = this.deviceDataPro(result);
            this.dataList = result;
            result = null;
          }
        }
      });
    },
    deviceDataPro(devices, parentName) {
      let list = {};
      if (devices && devices.length) {
        devices.forEach((item) => {
          if (item.nodeType === "device") {
            list[item.id] = {
              areaName: parentName,
              ...item
            };
          } else if (item.nodeType === "area") {
            list = Object.assign(
              list,
              this.deviceDataPro(item.children, item.name)
            );
          }
        });
      }
      return list;
    },
    handleCollection(data) {
      this.$emit("handleCollection", data);
    },
    getChosenCount() {
      return this.cameraData.length;
    },
    // 单击
    getCheckNode(nodeData) {
      if (nodeData.nodeType !== "area") {
        this.$emit("deviceClick", nodeData);
      } else {
        this.$emit("areaClick", nodeData);
      }
    },
    // 业务页面获取选中的设备/区域列表
    getCheckedNodes() {
      return {
        area: this.checkedArea || [],
        device: this.checkedDevice || []
      };
    },
    // 多选
    checkChange(node, checkData) {
      // console.log("摄像机选中节点", node);
      // 当前被选中节点
      let checkNodes = checkData.checkedNodes;
      console.log(checkNodes);
      this.checkedArea = [];
      this.checkedDevice = [];
      checkNodes.forEach((item) => {
        if (item.nodeType == "device") {
          this.checkedDevice.push(item);
        } else {
          this.checkedArea.push(item);
        }
      });
      this.cameraData = this.checkedDevice;
      this.$emit("cameraData", this.checkedDevice, this.checkedArea, node);
    },
    // 判断是否含有子节点
    checkChildNodes(str, arr) {
      for (let item of arr) {
        if (item.name.search(str.trim()) != -1) {
          this.expandedKeys.push(item.id);
        }
        if (item.children.length > 0) {
          this.checkChildNodes(str, item.children);
        }
      }
    },
    setChecked(deviceId) {
      this.$refs.appAreaTree.setCheckedKeys(deviceId);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.app-area-list {
  .showIcon {
    @include set_theme_color(color, main-theme-color);
    &:hover {
      color: #fff;
    }
  }
  height: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  .search-box {
    margin-bottom: 10px;
    border: 1px solid #C0C4CC;
    // background: #0d121c;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    :deep .el-input__inner {
      // background: ##0D121C;
      border: none !important;
      height: 30px;
    }
    span {
      height: 20px;
    }
    img {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
  .showDrag {
    max-width: 260px;
    // cursor: move;
  }
  .node {
    position: relative;
    display: flex;
    width: 100%;
    .node-cover {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &.out-line {
      color: #757373;
      .icon {
        color: #757373;
      }
    }
    .camera-type-icon {
      text-align: right;
      flex: 1;
      margin-right: 10px;
    }
  }
  .area-container {
    flex: 1;
    overflow: hidden;

    .area-node-icon {
      margin-right: 5px;
    }
    .iconfont-lunan {
      margin-right: 5px;
    }
  }
  .scroll-bar {
    height: 95%;
    z-index: 1;
    padding-bottom: 5px;
    .full-height {
      padding: 5px 0;
      /deep/.el-tree-node__content {
        &:hover {
          // @include set_theme_color(background-color, main-theme-color);
        }
      }
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
      height: 100%;
      margin-bottom: 0px !important;
    }
  }
  :deep .el-tree-node__content {
    height: 35px;
    line-height: 35px;
    // &:hover {
    //   background: rgb(45, 73, 118);
    // }
    .custom-tree-node {
      width: 100%;
      display: flex;
      justify-content: space-between;
      span {
        display: inline-block;
        width: 115px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    &:before {
      margin-top: -26px !important;
    }
  }
}
</style>
